import ChannelList from './List'
import ChannelEdit from './Edit'
import ChannelCreate from './Create'

export default {
  list: ChannelList,
  edit: ChannelEdit,
  create: ChannelCreate
}
